module.exports = __webpack_public_path__ + "assets/images/351744ed24c59888349369be8a2d8f24.jpg";